import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { Checkbox, Form, Input } from 'antd';
import LoadableButton from "../../../../../components/buttons/LoadableButton.jsx";
import { AddWithdrawRequestApi } from '../../../../../api/request/wallet/withdraw.js';

const UsdtWithdraw = ({ amount, resetAll, withdrawalMethod, addressLabel }) => {
    const [form] = Form.useForm();
    const { userDetails } = useSelector(state => state.user);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (values) => {
        setIsLoading(true);
        try {
            const params = {
                userId: userDetails?._id,
                amount: Number(amount),
                withdrawalMethod,
                walletAddress: values?.walletAddress
            };

            const { data } = await AddWithdrawRequestApi(params);
            if (data?.success) {
                toast.success(data?.message);
                form?.resetFields();
                resetAll();
            } else if (data?.error?.message) {
                toast.error(data?.error?.message);
            }
        } catch (error) {
            if (error?.response?.data?.error?.message)
                toast.error(error?.response?.data?.error?.message);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <div className='h-full'>
            <Form form={form} layout="vertical" className='space-y-5 flex flex-col justify-between h-full' onFinish={handleSubmit}>
                <div className="grid md:grid-cols-2 gap-5">
                    <Form.Item
                        name='walletAddress'
                        label={<span className="text-lg text-gray-500 font-medium">{addressLabel}</span>}
                        rules={[{ required: true, message: `Please enter ${addressLabel}.` }]}
                    >
                        <Input placeholder={addressLabel} size='large' />
                    </Form.Item>
                </div>
                <div className="space-y-5">
                    <Form.Item
                        name='conditions'
                        valuePropName="checked"
                        rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions.')) }]}
                    >
                        <Checkbox className='mt-4'>
                            Yes, I agreed to the <Link to={'/terms_&_conditions'} className='primary hover:underline duration-300'>Terms and conditions</Link>
                        </Checkbox>
                    </Form.Item>

                    <LoadableButton
                        className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'
                        type="submit"
                        lable='Submit'
                        isLoading={isLoading}
                        loadingLable='Adding request...'
                    />
                </div>
            </Form>
        </div>
    )
}

export default UsdtWithdraw
